/** Shown on every product detail page (design badges). */
export const PRODUCT_DETAIL_STATIC_TAGS = ['Naturally raised', 'FARE lab tested'];

/** Dot-separated metadata line under the product title (excludes subCategory — shown as its own tag). */
export function buildProductAttributeLine(product) {
  if (!product) return '';
  const parts = [];
  if (product.metadata?.age) parts.push(String(product.metadata.age).trim());
  if (product.metadata?.style) parts.push(String(product.metadata.style).trim());
  return parts.filter(Boolean).join(' · ');
}

/** Gross / net line on the meat format card. */
export function formatGrossNetWeights(product) {
  if (!product) return null;
  const parts = [];
  if (product.grossWeight) parts.push(`Gross ${String(product.grossWeight).trim()}`);
  if (product.netWeight) parts.push(`Net ${String(product.netWeight).trim()}`);
  return parts.length ? parts.join(' · ') : null;
}

/** True when product offers a live-bird format (positive `livePrice`). */
export function hasLiveBirdFormat(product) {
  const raw = product?.livePrice;
  if (raw == null || String(raw).trim() === '') return false;
  const amount = Number(raw);
  return Number.isFinite(amount) && amount > 0;
}

/** Live-bird format price label; null when product has no positive `livePrice`. */
export function formatLiveBirdPriceLabel(product) {
  if (!hasLiveBirdFormat(product)) return null;
  const amount = Number(product.livePrice);
  const unit = String(product?.quantity || '').toUpperCase() === 'KG' ? '/kg' : '';
  return `₹${amount}${unit}`;
}

export function stockBadgeLabel(product, storeName) {
  if (!product?.isStockAvailable) return 'Out of stock';
  const store = storeName ? String(storeName).trim() : '';
  return store ? `In stock · ${store}` : 'In stock';
}
